import { Controller } from "@hotwired/stimulus"

// Generic modal controller that ensures proper Bootstrap modal handling
export default class extends Controller {
  static values = { 
    autoShow: Boolean,
    backdrop: { type: String, default: 'true' },
    keyboard: { type: Boolean, default: true },
    focus: { type: Boolean, default: true }
  }
  
  connect() {
    // Ensure we have a modal element
    if (!this.element.classList.contains('modal')) {
      console.warn('Modal controller attached to non-modal element:', this.element);
      return;
    }
    
    // Get or create Bootstrap modal instance with proper config
    const config = {
      backdrop: this.backdropValue === 'static' ? 'static' : this.backdropValue === 'true',
      keyboard: this.keyboardValue,
      focus: this.focusValue
    };
    
    this.modal = bootstrap.Modal.getOrCreateInstance(this.element, config);
    
    // Show modal automatically if specified
    if (this.autoShowValue) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => this.show(), 0);
    }
    
    // Set up event listeners for common modal events
    this.element.addEventListener('shown.bs.modal', this.handleShown.bind(this));
    this.element.addEventListener('hidden.bs.modal', this.handleHidden.bind(this));
  }
  
  disconnect() {
    // Remove event listeners
    this.element.removeEventListener('shown.bs.modal', this.handleShown.bind(this));
    this.element.removeEventListener('hidden.bs.modal', this.handleHidden.bind(this));
    
    // Don't dispose the modal here as it might be reused
    // The modal manager will handle cleanup on navigation
  }
  
  show() {
    if (this.modal) {
      this.modal.show();
    }
  }
  
  hide() {
    if (this.modal) {
      this.modal.hide();
    }
  }
  
  toggle() {
    if (this.modal) {
      this.modal.toggle();
    }
  }
  
  handleShown(event) {
    // Dispatch custom event for other controllers to listen to
    this.dispatch('shown', { detail: { modal: this.modal } });
    
    // Focus first input if present
    const firstInput = this.element.querySelector('input:not([type="hidden"]), textarea, select');
    if (firstInput && this.focusValue) {
      firstInput.focus();
    }
  }
  
  handleHidden(event) {
    // Dispatch custom event
    this.dispatch('hidden', { detail: { modal: this.modal } });
    
    // Clear any form data if present
    const form = this.element.querySelector('form');
    if (form && form.dataset.resetOnHide !== 'false') {
      form.reset();
    }
  }
}